import React from 'react';
import { ShieldAlert } from 'lucide-react';
import DashboardLayout from './DashboardLayout';

export default function AccessDenied({ title = 'Access Denied', message = 'You do not have permission to access this page.' }) {
  return (
    <DashboardLayout title={title}>
      <div className="min-h-[55vh] flex items-center justify-center">
        <div className="max-w-md w-full rounded-2xl border border-amber-200 bg-white p-8 text-center shadow-sm">
          <div className="mx-auto mb-4 w-14 h-14 rounded-2xl bg-amber-50 flex items-center justify-center text-amber-700">
            <ShieldAlert className="w-7 h-7" />
          </div>
          <h2 className="text-xl font-bold text-slate-900">{title}</h2>
          <p className="mt-2 text-sm text-slate-600">{message}</p>
        </div>
      </div>
    </DashboardLayout>
  );
}

